<script setup lang="ts">
import { computed } from 'vue'
import UIKit, { type ITableColumn } from '@pocketprep/ui-kit'
import BrandColors from '@pocketprep/ui-kit/pocketprep-export.module.scss'
import type { TStudentQuestionRow } from '@/store/types'

const { Icon } = UIKit

const props = withDefaults(
    defineProps<{
        row: TStudentQuestionRow
        column: ITableColumn
        numOfQuestions?: number
    }>(),
    { numOfQuestions: 0 }
)

const brandColors = BrandColors

const questionPrompt = computed(() => {
    return props.row.scenarioPartLabel
        ? `${props.row.scenarioPartLabel}: ${props.row.prompt}`
        : props.row.prompt
})
</script>

<template>
    <div
        class="student-question-row"
    >
        <template v-if="props.column.propName === 'question'">
            <div v-if="props.column.propName === 'question'" class="student-question-row__subject">
                {{ props.row.subject }}
            </div>
        </template>
        <template v-if="props.column.propName === 'question'">
            <div
                class="student-question-row__prompt"
                :class="{'student-question-row__prompt--all': props.numOfQuestions > 3 }"
                v-html="questionPrompt"
            />
        </template>
        <template v-else-if="props.column.propName === 'numStudentFlagged'">
            <div class="student-question-row__flagged">
                <Icon
                    v-if="props.row.isFlagged"
                    class="student-question-row__flag-icon"
                    :secondary-color="brandColors.bananaBread"
                    type="flagFeedback"
                />
                <Icon
                    v-if="props.row.isCorrect"
                    class="student-question-row__correct-icon"
                    type="correct"
                />
                <Icon
                    v-else-if="(!props.row.isCorrect && props.row.isAnswered)"
                    class="student-question-row__incorrect-icon"
                    type="incorrect"
                />
                <div
                    v-else-if="!props.row.isAnswered"
                    class="student-question-row__unanswered"
                />
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>


.student-question-row {
    &__question {
        display: flex;
        flex-wrap: wrap;
    }

    &__subject {
        margin-bottom: 6px;
        color: $slate;
        font-size: 14px;
        line-height: 18px;
        width: 254px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }

    &__prompt {
        color: $brand-black;
        white-space: normal;
        font-size: 15px;
        line-height: 22px;
        width: 645px;

        :deep(span) {
            position: relative;
            z-index: 1;

            &::before {
                border-radius: 4px;
                content: '';
                height: 20px;
                width: calc(100% + 2px);
                left: -1px;
                top: 0;
                background: $buttermilk;
                z-index: -1;
                position: absolute;
            }
        }

        &--all {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    &__flagged {
        display: flex;
        height: 5px;
        padding-right: 8px;
        max-width: 50px;
    }

    &__flag-icon {
        margin-top: 2px;
        margin-bottom: auto;
        color: #ce8500;
    }

    &__correct-icon {
        margin-left: 3px;
        margin-top: 2px;
        margin-bottom: auto;
        color: $cadaverous;
    }

    &__incorrect-icon {
        margin-left: 3px;
        margin-top: 2px;
        margin-bottom: auto;
        color: $pepper;
    }

    &__unanswered {
        width: 22px;
        height: 21px;
        margin-left: 3px;
    }
}
</style>
